// Uploading a question attachment: presign via the API, PUT the bytes to S3.
import { api, QuestionMedia } from '../api/rest';

/** Client-side cap; S3 would accept more but a phone has to download it. */
export const MAX_MEDIA_BYTES = 15 * 1024 * 1024;

export const MEDIA_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif,audio/mpeg,audio/mp4,audio/ogg,audio/wav,audio/aac';

export async function uploadMedia(file: File): Promise<Required<QuestionMedia>> {
  if (file.size > MAX_MEDIA_BYTES) throw new Error('media too large (max 15 MB)');
  const type = file.type || guessType(file.name);
  const p = await api.presignMedia(type);
  // Content-Type is part of the signature: send exactly what was presigned.
  const res = await fetch(p.uploadUrl, { method: 'PUT', body: file, headers: { 'content-type': p.contentType } });
  if (!res.ok) throw new Error(`upload failed (${res.status})`);
  return { mediaUrl: p.mediaUrl, mediaType: p.mediaType };
}

/** Some browsers leave File.type empty for less common audio; fall back on the extension. */
function guessType(name: string): string {
  const ext = name.toLowerCase().split('.').pop() ?? '';
  return (
    { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', gif: 'image/gif',
      mp3: 'audio/mpeg', m4a: 'audio/mp4', ogg: 'audio/ogg', wav: 'audio/wav', aac: 'audio/aac' }[ext] ?? ''
  );
}
